module.exports = __webpack_public_path__ + "img/slide_6.4c67156a.jpg";